import { ValidationMessage } from '../../components/form'

export { EmailValidation, PasswordValidation }

const EmailValidation = {
  rules: {},
  messages: [
    <ValidationMessage key="typeMismatch" match="typeMismatch">
      must be a valid email address
    </ValidationMessage>,
  ],
}

const PasswordValidation = {
  rules: {
    /** @see https://github.com/Synqly/lepton/blob/7e549bc6194bf08541fd942cfadd17b02b43ecf0/utils/password/password.go#L13-L16 */
    pattern: '.{8,72}',
  },
  messages: [
    <ValidationMessage key="patternMismatch" match="patternMismatch">
      must be 8-72 characters
    </ValidationMessage>,
  ],
}
